

// MyCompm.js

import React, { useEffect } from 'react'; // Import useEffect
import { useQuery, gql } from '@apollo/client';

const GET_ID_SEQ = gql`
  query GetIdSeq($type: String!) {
    tbl_id_SEQ(where: { type: { _eq: $type } }) {
      id_seq
    }
  }
`;

const MyCompm = ({ type, onIdSeqChange }) => {
  const { loading, error, data } = useQuery(GET_ID_SEQ, {
    variables: { type },
  });

  useEffect(() => {
    if (!loading && !error) {
      const idSeq = data.tbl_id_SEQ[0]?.id_seq;
      if (onIdSeqChange) {
        onIdSeqChange(idSeq);
      }
    }
  }, [data, loading, error, onIdSeqChange]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  const idSeq = data.tbl_id_SEQ[0]?.id_seq;

  return (
    console.log(idSeq),
    <div>
      <p>Type: {type}</p>
      <p>ID Seq: {idSeq}</p>
     
    </div>
  );
};

export default MyCompm;








/*const GET_ID_SEQ = gql`
  query GetIdSeq($type: String!) {
    tbl_id_SEQ(where: { type: { _eq: $type } }) {
      id_seq
    }
  }
`;

const UPDATE_ID_SEQ = gql`
  mutation UpdateIdSeq($type: String!, $id_seq: Int!) {
    update_tbl_id_SEQ(
      where: { type: { _eq: $type } }
      _set: { id_seq: $id_seq }
    ) {
      returning {
        id_seq
      }
    }
  }
`;


export const MyCompm = ({ type }) => {
  const { loading, error, data } = useQuery(GET_ID_SEQ, {
    variables: { type },
  });

  console.log(type); 



};
export default MyCompm ;*/

